const c3FirebaseConfig = {
  development: {
    config: {
      apiKey: "AIzaSyDHIAyM91bL1-2t_rsRxw6vYag2lzTeEu4",
      authDomain: "fbk-development.firebaseapp.com",
      databaseURL: "https://fbk-development.firebaseio.com",
      projectId: "fbk-development",
      storageBucket: "fbk-development.appspot.com",
      messagingSenderId: "1012743322137",
      appId: "1:1012743322137:web:e3cf8170f8b6e15b954888",
      measurementId: "G-M6VMYXLSX7",
    },
    publicVapidKey:
      "BJvN-wCtO-5uPBevXveK-g6nkYrNlZ7QkGTMi7nB3b5SnyKFf6LCtUOfG1BqW-ieXfs-3hj3otYWteDYAJZBDIg",
  },
  testragusa: {
    config: {
      apiKey: "AIzaSyDfvxCvrFBr4FFMbF-5LYOpisJTb6Ho9nM",
      authDomain: "ragusa-9c1b8.firebaseapp.com",
      projectId: "ragusa-9c1b8",
      storageBucket: "ragusa-9c1b8.appspot.com",
      messagingSenderId: "252234631541",
      appId: "1:252234631541:web:af09e0ccf6df801e74ab3c",
      measurementId: "G-6S6G9ZFVBC",
    },
    publicVapidKey:
      "BNyPKHanIWQoWmjZ95vtwE5bHmJmxMkTRErsNTnQIcDsms9yLH1ELx-7ReVit39NgEVnX93WNIem3l-oXbM564A",
  },
  productionragusa: {
    config: {
      apiKey: "AIzaSyDfvxCvrFBr4FFMbF-5LYOpisJTb6Ho9nM",
      authDomain: "ragusa-9c1b8.firebaseapp.com",
      projectId: "ragusa-9c1b8",
      storageBucket: "ragusa-9c1b8.appspot.com",
      messagingSenderId: "252234631541",
      appId: "1:252234631541:web:af09e0ccf6df801e74ab3c",
      measurementId: "G-6S6G9ZFVBC",
    },
    publicVapidKey:
      "BNyPKHanIWQoWmjZ95vtwE5bHmJmxMkTRErsNTnQIcDsms9yLH1ELx-7ReVit39NgEVnX93WNIem3l-oXbM564A",
  },
  production7laghi: {
    config: {
      apiKey: "AIzaSyB2jomZIHn8A8R5kRArk6oA3Y-bUSbL_Lc",
      authDomain: "visita-7387d.firebaseapp.com",
      projectId: "visita-7387d",
      storageBucket: "visita-7387d.appspot.com",
      messagingSenderId: "35647209503",
      appId: "1:35647209503:web:6260019d3267965a11552a",
      measurementId: "G-RVCCKXBZX9"
    }
  },
  trecdev: {
    config: {
      apiKey: 'AIzaSyC3CE4s8bfQaTi2Dl60NDqFTjKVlNNgmlc',
      authDomain: 'trec-plus.firebaseapp.com',
      databaseURL: 'https://trec-plus.firebaseio.com',
      projectId: 'trec-plus',
      storageBucket: 'trec-plus.appspot.com',
      messagingSenderId: '314286849818',
      appId: '1:314286849818:web:c6d446e60910ac2ef576a3',
      measurementId: 'G-Q5CKSQBPWF'
    }
  },
  trecprod: {
    config: {
      apiKey: 'AIzaSyC3CE4s8bfQaTi2Dl60NDqFTjKVlNNgmlc',
      authDomain: 'trec-plus.firebaseapp.com',
      databaseURL: 'https://trec-plus.firebaseio.com',
      projectId: 'trec-plus',
      storageBucket: 'trec-plus.appspot.com',
      messagingSenderId: '314286849818',
      appId: '1:314286849818:web:c6d446e60910ac2ef576a3',
      measurementId: 'G-Q5CKSQBPWF'
    }
  },
  dedadev: {
    config: {
      apiKey: "AIzaSyDfvxCvrFBr4FFMbF-5LYOpisJTb6Ho9nM",
      authDomain: "ragusa-9c1b8.firebaseapp.com",
      projectId: "ragusa-9c1b8",
      storageBucket: "ragusa-9c1b8.appspot.com",
      messagingSenderId: "252234631541",
      appId: "1:252234631541:web:af09e0ccf6df801e74ab3c",
      measurementId: "G-6S6G9ZFVBC",
    },
    publicVapidKey:
      "BNyPKHanIWQoWmjZ95vtwE5bHmJmxMkTRErsNTnQIcDsms9yLH1ELx-7ReVit39NgEVnX93WNIem3l-oXbM564A",
    // config: {
    //   apiKey: "AIzaSyA7g8chMYufnvPNDSzuwNJqA9f4sz0TYS8",
    //   authDomain: "piattaformasalutededadev.firebaseapp.com",
    //   projectId: "piattaformasalutededadev",
    //   storageBucket: "piattaformasalutededadev.appspot.com",
    //   messagingSenderId: "546403915345",
    //   appId: "1:546403915345:web:c9479ead715501ad028a70"
    // },
    // publicVapidKey:
    //   "BDx7rLBhz8lILvAh6E-yZ23pz5Slzd1ptxoUBhi8DymXy7SF_7UOz9RdWXE99svJ4IE668RF_40cd7g0-orA-2I",
  }
};

// If script is used in main thread of service worker -> save config in self (i.e. window or self)
if (self) {
  self.c3FirebaseConfig = c3FirebaseConfig;
}
